import React, { useState, useEffect } from "react";
import TopHeading from "../Heading/TopHeading";
import UserServiceBox from "./UserServiceBox";
import { AddServiceModal } from "./AddServiceModal";
import axios from "../../axios";
import { toast } from "react-toastify";
import { Loader, NoContent, Pagination } from "../UI";

export default function UserServicesContent() {
  const authToken = localStorage.getItem("access_token");
  const isAdmin = localStorage.getItem("isAdmin");
  const [services, setServices] = useState([]);
  const [currentServices, setCurrentServices] = useState([]);
  const itemsPerPage = 6;
  const [isLoading, setIsLoading] = useState(true);

  const updateService = (id, values) => {
    values.datesAllowed = values.datesAllowed.toString();
    setIsLoading(true);
    axios
      .put(
        "/services/" + id,
        { ...values },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            toast.success(response.data.message);
            fetchServices();
          } else {
            toast.warn("No response from server");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Something went wrong");
        console.log(error);
        setIsLoading(false);
      });
  };

  const fetchServices = () => {
    axios
      .get("/services", {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            isAdmin != 0
              ? setServices(response.data)
              : setServices(
                  response.data.filter((item) => item.status === "published")
                );
          } else {
            toast.warn("No response from server");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Couldn't load services");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <section className="user-services-content">
      <div className="container">
        <div className="row g-0">
          <div className="col-md-12">
            <TopHeading title="Activities" />
            {isAdmin != 0 && <AddServiceModal />}
            <div className="services light-bg corner-radius p-4 mb-3 custom-scrollbar">
              <h5 className="mb-3">Our Activities</h5>
              <div className="row g-0">
                {!isLoading ? (
                  services.length ? (
                    services.length > itemsPerPage ? (
                      currentServices.map((item) => {
                        return (
                          <UserServiceBox
                            data={item}
                            key={item.serviceId}
                            updateService={updateService}
                          />
                        );
                      })
                    ) : (
                      services.map((item) => {
                        return (
                          <UserServiceBox
                            data={item}
                            key={item.serviceId}
                            updateService={updateService}
                          />
                        );
                      })
                    )
                  ) : (
                    <NoContent />
                  )
                ) : (
                  <Loader />
                )}
              </div>
              {services.length > itemsPerPage && (
                <div className="d-flex justify-content-end">
                  <Pagination
                    data={services}
                    setCurrentItems={setCurrentServices}
                    itemsPerPage={itemsPerPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
